<template lang="html">
  <div class="admin-faq-wrapper">
    <div class="title">
      <span>FAQ</span>
      <locale-picker />
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>naziv</td>
            <td style="width: 150px;"></td>
            <td style="width: 100px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="faq in faqs" :key="faq.faq_id">
            <td>
              {{faq.name}}
            </td>
            <td>
              <div @click="openEditModal(faq)" class="btn">
                izmeni {{$route.params.lang}}
              </div>
            </td>
            <td style="width: 150px;">
              <div @click="confirmDeleteFaq(faq)" class="btn">
                obriši
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="action-wrapper">
      <div @click="openNewModal" class="btn">
        dodaj FAQ
      </div>
    </div>
  </div>
</template>

<script>
import LocalePicker from '@/components/header/LocalePicker.vue'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminFiles',
  components: {
    LocalePicker
  },
  data () {
    return {
      faqs: []
    }
  },
  mounted () {
    this.getAllFaqs()
  },
  methods: {
    getAllFaqs () {
      api.getAllFaqs().then(res => {
        this.faqs = res.data.data
      })
    },
    confirmDeleteFaq (faq) {
      let modalData = {
        title: 'Jeste li sigurni da želite da obrišete ovaj faq',
        ok: () => {
          this.deleteFaq(faq)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    deleteFaq (faq) {
      api.deleteFaq(faq).then(res => {
        this.getAllFaqs()
      }).catch(e => {
        console.log(e);
      })
    },
    openNewModal () {
      let modalData = {
        ok: (name) => {
          this.createFaq(name)
        }
      }
      let params = {
        modalData: modalData,
        component: 'addFaq'
      }
      eventBus.$emit('openModal', params)
    },
    createFaq (name) {
      let params = {
        name: name
      }
      api.createFaq(params).then(() => {
        this.getAllFaqs()
      }).catch(e => {
        console.log(e);
      })
    },
    openEditModal (faq) {
      let modalData = {
        title: 'Izmeni "' + faq.name + '"',
        faq: faq,
        ok: (editedFaq) => {
          this.editFaqLocale(editedFaq, faq.id)
        }
      }
      let params = {
        modalData: modalData,
        component: 'editFaqLocale'
      }
      eventBus.$emit('openModal', params)
    },
    editFaqLocale (editedFaq, id) {
      api.editFaqLocale(editedFaq, id).then(res => {
        this.getAllFaqs()
      }).catch(e => {
        console.log(e);
      })
    }
  },
  watch: {
    '$route.params.lang': {
      handler: function () {
        this.getAllFaqs()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-faq-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 100px);
    overflow: auto;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .btn:last-child {
      margin-left: 10px;
    }
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  table {
    margin-bottom: 20px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
